import { ApolloClient } from "apollo-client";
import { setContext } from "apollo-link-context";
import { InMemoryCache } from "apollo-cache-inmemory";
import { createHttpLink } from "apollo-link-http";
import { onError } from "apollo-link-error";
import { ApolloLink } from "apollo-link";

import store from "../store";

const baseLink = createHttpLink({
  uri: process.env.VUE_APP_API_URL.concat("/graphql"),
  fetch,
  credentials: "omit",
});

const authLink = setContext((_, { headers }) => ({
  headers: {
    ...headers,
    authorization: `Bearer ${store.state.auth.bearer}`,
  },
}));

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors)
    graphQLErrors.map(({ message, locations, path }) =>
      console.log(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`,
      ),
    );
  if (networkError) console.log(`[Network error]: ${networkError}`);
});

export const Cache = new InMemoryCache();
export const apolloClient = new ApolloClient({
  link: ApolloLink.from([
    authLink.concat(baseLink),
    errorLink.concat(baseLink),
  ]),
  cache: Cache,
  connectToDevTools: true,
});
